import {Component, Input, OnInit} from '@angular/core';
import {DigitalSignEventsService} from '@shared/components/core-sign/services/digital-sign-events.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-operator-procedure-end',
	templateUrl: './digital-sign-operator-procedure-end.component.html',
	styleUrls: ['./digital-sign-operator-procedure-end.component.scss']
})
export class DigitalSignOperatorProcedureEndComponent implements OnInit {

	@Input() operatorSignedDocuments: any[];
	@Input() operatorToken: string;
	translateContext = TranslateContext;

	constructor(
		private digitalSignEventsService: DigitalSignEventsService
	) {
	}

	ngOnInit(): void {
	}

	downloadInfocertDocument(index: number): void {
		if (!!this.operatorSignedDocuments && index < this.operatorSignedDocuments.length) {
			this.digitalSignEventsService.downloadInforcertDocumentSubject.next({
				token: this.operatorToken,
				mUrl: this.operatorSignedDocuments[index].url,
				name: this.operatorSignedDocuments[index].name
			});
		}
	}

	abortProcedure(): void {
		this.digitalSignEventsService.abortOperatorProcedureSubject.next();
	}

	goToCustomerProcedure(): void {
		this.digitalSignEventsService.procedureGoToNextStepSubject.next(true);
	}
}
